import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Router navigation doesn't reset scroll on its own. Jump to the top on a new
 * path, but leave in-page hash links and back/forward restoration alone.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
